/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menupagetitle2Inputs */

const en_menupagetitle2 = /** @type {(inputs: Menupagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menus`)
};

const de_menupagetitle2 = /** @type {(inputs: Menupagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte`)
};

/**
* | output |
* | --- |
* | "Menus" |
*
* @param {Menupagetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menupagetitle2 = /** @type {((inputs?: Menupagetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menupagetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menupagetitle2(inputs)
	return de_menupagetitle2(inputs)
});
export { menupagetitle2 as "menuPageTitle" }